import React from "react";
import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image  } from '@react-pdf/renderer';
import Prompt from "../assets/fonts/Sarabun/Prompt-Bold.ttf";
import { colors } from "../configs";
import { stringFullDate } from "../Utility/dateTime";

const { white, one } = colors;

Font.register(
  {
    family: "Prompt",
    src: Prompt,
  }
);

function LargeHorizontalWithPro({
    data
}) {
  return    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
                {data.map((item,index)=>{
                    const { name, unit, price, promotion:{ qty, endDate, price:promotionPrice }, barcode, barcodeImage } = item;
                    const normalPrice = qty*price
                    const save = normalPrice - promotionPrice
                    return <Page size="A4" orientation="landscape" key={index}  >
                            <View style={{width:"100%",alignItems:'center', borderWidth:0.5}} >
                                <View style={{backgroundColor:'#de2702', width:'100%', justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, color:white }} >
                                    <Text style={{ fontSize:65 }} numberOfLines={2} >ลดพิเศษ</Text>
                                </View>
                                <View style={{width:'100%', paddingLeft:10, marginTop:-10, height: 140}} >
                                    <Text style={{ fontSize:35 }}>{name}</Text>
                                    <Text style={{ fontSize:35 }}>{qty} {unit} ปกติราคา {normalPrice} บาท</Text>
                                </View>
                                <Text style={{ fontSize:200, marginBottom:-50, marginTop:-70, paddingBottom:0, color:one }} >{promotionPrice}</Text>
                                <Text style={{ fontSize:30, color:one }} >(ประหยัด {save.toFixed(2)} บาท)</Text>
                                <Text style={{ fontSize:30 }} >ราคานี้ จนถึง {stringFullDate(endDate)}</Text>
                                <Text style={{ fontSize:20 }} >{barcode}</Text>
                                {barcodeImage && <Image style={{ width:'450px'}} src={barcodeImage} />}
                            </View>
                        </Page>
                })}

            </Document>
}

export default LargeHorizontalWithPro;
